module.exports = __webpack_public_path__ + "img/steering-wheel-green.c31d32a5.svg";